import { useEffect, useState } from "react";
import { BarChart3, Eye, ScanFace, Images, CheckSquare, Download, TrendingUp } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, RadialBarChart, RadialBar, PolarAngleAxis } from "recharts";
import api from "@/lib/api";
import { Loader } from "@/components/common/Loader";
import { PageHeader, StatCard } from "@/components/dashboard/ui";

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <Loader />;
  const t = data.totals;
  const ring = [{ name: "completion", value: t.completion_rate, fill: "#d4af37" }];

  return (
    <div>
      <PageHeader title="Analytics" subtitle="Understand how clients engage with your galleries." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Images} label="Total Photos" value={t.photos.toLocaleString()} accent />
        <StatCard icon={Eye} label="Gallery Views" value={t.views.toLocaleString()} />
        <StatCard icon={ScanFace} label="Selfie Searches" value={t.searches.toLocaleString()} />
        <StatCard icon={Images} label="Photos Found" value={t.photos_found.toLocaleString()} />
        <StatCard icon={CheckSquare} label="Photos Selected" value={t.selected.toLocaleString()} />
        <StatCard icon={Download} label="Downloads" value={t.downloads.toLocaleString()} />
        <StatCard icon={BarChart3} label="Events" value={t.events} />
        <StatCard icon={TrendingUp} label="Completion" value={`${t.completion_rate}%`} accent />
      </div>

      <div className="grid lg:grid-cols-3 gap-4 mt-4">
        <div className="lg:col-span-2 rounded-2xl border border-border bg-black/40 p-6">
          <div className="text-white font-medium mb-4">Photos & selections per event</div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={data.per_event} barGap={4}>
              <XAxis dataKey="name" stroke="#666" fontSize={11} tickLine={false} axisLine={false} interval={0} tick={{ width: 80 }} />
              <YAxis stroke="#666" fontSize={11} tickLine={false} axisLine={false} />
              <Tooltip contentStyle={{ background: "#111", border: "1px solid #262626", borderRadius: 12, color: "#fff" }} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
              <Bar dataKey="photos" fill="#3a3a3a" radius={[6, 6, 0, 0]} />
              <Bar dataKey="selected" fill="#d4af37" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="rounded-2xl border border-border bg-black/40 p-6 flex flex-col items-center justify-center">
          <div className="text-white font-medium self-start mb-2">Selection completion</div>
          <ResponsiveContainer width="100%" height={220}>
            <RadialBarChart innerRadius="70%" outerRadius="100%" data={ring} startAngle={90} endAngle={-270}>
              <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
              <RadialBar background={{ fill: "#1e1e1e" }} dataKey="value" cornerRadius={20} />
            </RadialBarChart>
          </ResponsiveContainer>
          <div className="font-serif text-4xl text-gradient-gold -mt-32">{t.completion_rate}%</div>
          <div className="text-xs text-muted-foreground mt-24">of surfaced photos selected</div>
        </div>
      </div>
    </div>
  );
}
